import React from "react";
import { useLocation, useNavigate } from "@remix-run/react";
import { useApi } from "@core/api";
import { useSelectedPatient } from "./SelectedPatientProvider";

/**
 * When navigation includes ?loc=office (e.g. "In-Office Order" in homepage tabs or footer),
 * select the synthetic In-Office patient in the header/cart context and remove the param.
 */
export const InOfficeOrderingFromQuery: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const api = useApi();
  const { setPatient, patients } = useSelectedPatient();

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("loc") !== "office") {
      return;
    }

    const nextParams = new URLSearchParams(location.search);
    nextParams.delete("loc");
    const nextSearch = nextParams.toString();

    void (async () => {
      try {
        let list = patients;
        if (!list.length) {
          const res = await api.ListProviderPatients({ PageSize: 100 });
          list = res.Results ?? [];
        }
        const office = list.find((p) => p.Key?.startsWith("in-office-use"));
        if (office) {
          setPatient(office);
        }
      } finally {
        navigate(
          { pathname: location.pathname, search: nextSearch ? `?${nextSearch}` : "" },
          { replace: true },
        );
      }
    })();
  }, [api, location.pathname, location.search, navigate, patients, setPatient]);

  return null;
};
